import React, { useState } from 'react';
import axios from 'axios';
import { CheckCircle, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const WhatsApp = () => {
  const [syncing, setSyncing] = useState(false);

  const handleSyncContacts = async () => {
    setSyncing(true);
    try {
      const response = await axios.post(`${API}/whatsapp/sync-contacts`);
      toast.success(response.data.message);
    } catch (error) {
      const errorMessage = error.response?.data?.detail || 'Erro ao sincronizar contatos';
      toast.error(errorMessage);
    }
    setSyncing(false);
  };

  return (
    <div data-testid="whatsapp-page">
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">WhatsApp</h1>
        <p className="text-gray-600">Sincronize seus contatos do WhatsApp</p>
      </div>

      <div className="max-w-2xl mx-auto">
        <Card className="border-0 shadow-lg">
          <CardHeader>
            <CardTitle className="flex items-center gap-3">
              <CheckCircle className="w-6 h-6 text-green-600" />
              Status da Conexão
            </CardTitle>
          </CardHeader>
          <CardContent>
            {/* Status Verde - WhatsApp Conectado */}
            <div className="text-center py-8">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-10 h-10 text-green-600" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">WhatsApp Conectado</h3>
              <p className="text-gray-600 mb-8">Sua conta está conectada e pronta para sincronizar</p>

              {/* Botão Sincronizar Contatos */}
              <Button
                onClick={handleSyncContacts}
                disabled={syncing}
                className="bg-gradient-to-r from-green-600 to-emerald-500 hover:from-green-700 hover:to-emerald-600 text-white px-8 py-3 text-lg"
              >
                {syncing ? (
                  <>
                    <RefreshCw className="w-5 h-5 mr-2 animate-spin" />
                    Sincronizando...
                  </>
                ) : (
                  <>
                    <RefreshCw className="w-5 h-5 mr-2" />
                    Sincronizar Contatos
                  </>
                )}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default WhatsApp;
